/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EarningsSummaryResponseDtoApiResponse } from '../models/EarningsSummaryResponseDtoApiResponse';
import type { FetchExpertPayoutsApiResponse } from '../models/FetchExpertPayoutsApiResponse';
import type { FetchTransactionsApiResponse } from '../models/FetchTransactionsApiResponse';
import type { TransactionDetailApiResponse } from '../models/TransactionDetailApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppEarningsService {
    /**
     * Get earnings summary and eligibility status
     * Returns earnings dashboard data (total earnings, this month, percentage change) along with eligibility status and pending setup actions.
     * @param thisMonthStartUtc Start of the current local month as a full ISO-8601 UTC timestamp.
     * @param nextMonthStartUtc Start of the next local month (= end of current month, exclusive) as a full ISO-8601 UTC timestamp.
     * @param prevMonthStartUtc Start of the previous local month as a full ISO-8601 UTC timestamp.
     * @param dateFrom Filter payout lookup from this UTC timestamp (inclusive). Derived from the duration filter selected in the UI.
     * @param dateTo Filter payout lookup up to this UTC timestamp (exclusive). Derived from the duration filter selected in the UI.
     * @returns EarningsSummaryResponseDtoApiResponse Earnings summary fetched
     * @throws ApiError
     */
    public static expertEarningsControllerGetSummaryV1(
        thisMonthStartUtc: string,
        nextMonthStartUtc: string,
        prevMonthStartUtc: string,
        dateFrom?: string,
        dateTo?: string,
    ): CancelablePromise<EarningsSummaryResponseDtoApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/earnings/summary',
            query: {
                'thisMonthStartUtc': thisMonthStartUtc,
                'nextMonthStartUtc': nextMonthStartUtc,
                'prevMonthStartUtc': prevMonthStartUtc,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
            },
        });
    }
    /**
     * Get paginated earnings transactions
     * Returns filtered, paginated list of transactions for the authenticated expert. Supports filtering by type (subscriptions, transactions, deductions), status, and time period.
     * @param type Filter by category
     * @param statuses Filter by one or more payment statuses
     * @param dateFrom Filter transactions on/after this UTC timestamp. Frontend should convert local day boundaries to UTC before sending.
     * @param dateTo Filter transactions on/before this UTC timestamp (exclusive).
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchTransactionsApiResponse Transactions fetched
     * @throws ApiError
     */
    public static expertEarningsControllerFetchTransactionsV1(
        type?: 'all' | 'subscriptions' | 'transactions' | 'deductions',
        statuses?: Array<'pending' | 'completed' | 'failed' | 'refunded'>,
        dateFrom?: string,
        dateTo?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<FetchTransactionsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/earnings/transactions',
            query: {
                'type': type,
                'statuses': statuses,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get paginated expert payouts
     * Returns a paginated list of payouts for the authenticated expert.
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchExpertPayoutsApiResponse Payouts fetched
     * @throws ApiError
     */
    public static expertEarningsControllerFetchPayoutsV1(
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<FetchExpertPayoutsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/earnings/payouts',
            query: {
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get transaction detail
     * Returns detailed information for a single transaction belonging to the authenticated expert.
     * @param id Transaction UUID
     * @returns TransactionDetailApiResponse Transaction detail fetched
     * @throws ApiError
     */
    public static expertEarningsControllerGetTransactionDetailV1(
        id: string,
    ): CancelablePromise<TransactionDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/earnings/transactions/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Transaction not found`,
            },
        });
    }
}
